export default __webpack_public_path__ + "static/media/promotionalProducts.45a02018.JPG";